import PropTypes from 'prop-types';
import { getLowerCaseSelector } from 'utils/clickme';

import useTrls from 'hooks/translation/useTrls';

import Label from 'components/Label';

import { InvoiceDreamPayerType as InvoicePayerType, InvoiceStatus as InvoiceStatusType } from 'store/models/invoices';

const InvoiceStatus = ({ status, useShortStatus = false, payerType }) => {
    const trl = useTrls();

    let lowerCaseStates = getLowerCaseSelector(status);
    if (useShortStatus && [InvoiceStatusType.WaitingDoc, InvoiceStatusType.Sending].includes(status)) {
        lowerCaseStates = getLowerCaseSelector(InvoiceStatusType.New);
    } else if (payerType === InvoicePayerType.Gift) {
        lowerCaseStates = 'credited';
    }
    return (
        <Label type={`status-${lowerCaseStates}`} dataQa="invoice-status">
            {trl(`InvoiceStatus.${lowerCaseStates}`)}
        </Label>
    );
};

InvoiceStatus.propTypes = {
    status: PropTypes.oneOf(Object.values(InvoiceStatusType)),
    useShortStatus: PropTypes.bool,
    payerType: PropTypes.oneOf(Object.values(InvoicePayerType)),
};

export default InvoiceStatus;
